var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFreebet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#freebet_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.657 17a.65.65 0 0 0 .65-.65v-5.16a.65.65 0 1 0-1.3 0v5.16c0 .36.292.65.65.65",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.275 11.188c0-.358.272-.65.608-.65h3.51c.335 0 .607.292.607.65 0 .36-.272.65-.608.65h-3.51c-.335 0-.607-.29-.607-.65m-8.623 3.03.627-.002.87-.003a1.837 1.837 0 0 0 0-3.675h-1.5a.65.65 0 0 0-.649.65v2.38a.65.65 0 0 0 .652.65m.647-1.302v-1.078h.85a.538.538 0 0 1 0 1.075z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m3.652 17 .738-.003 1.02-.003a2.039 2.039 0 0 0 0-4.078H3.65a.65.65 0 0 0-.65.65v2.784a.65.65 0 0 0 .652.65m.647-1.302v-1.482h1.11a.74.74 0 0 1 0 1.478l-1.025.003zm3.756.652c0 .36.29.65.65.65h2.173a.65.65 0 0 0 0-1.3H9.354v-3.86h1.524a.65.65 0 0 0 0-1.3H8.704a.65.65 0 0 0-.65.65z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.055 13.769c0 .359.29.65.65.65h2.013a.65.65 0 0 0 0-1.3H8.704a.65.65 0 0 0-.65.65ZM3.55 9.463c.303 0 .55-.291.55-.65V4.3h1.22c.303 0 .55-.291.55-.65S5.623 3 5.32 3H3.55c-.304 0-.55.291-.55.65v5.162c0 .359.246.65.55.65Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6.183c0 .359.246.65.55.65h1.63c.303 0 .549-.291.549-.65s-.246-.65-.55-.65H3.55c-.303 0-.549.29-.549.65Zm7.445 2.63c0 .359.246.65.55.65h1.84c.304 0 .55-.291.55-.65s-.246-.65-.55-.65h-1.29V4.301h1.29c.304 0 .55-.291.55-.65s-.246-.65-.55-.65h-1.84c-.303 0-.55.291-.55.65z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.445 6.232c0 .36.246.65.55.65H12.7c.303 0 .55-.29.55-.65 0-.359-.247-.65-.55-.65h-1.705c-.303 0-.55.291-.55.65m3.615 2.581c0 .359.247.65.55.65h1.84c.304 0 .55-.291.55-.65s-.246-.65-.55-.65h-1.29V4.301h1.29c.304 0 .55-.291.55-.65s-.246-.65-.55-.65h-1.84c-.303 0-.55.291-.55.65z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.06 6.232c0 .36.247.65.55.65h1.705c.303 0 .55-.29.55-.65 0-.359-.247-.65-.55-.65H14.61c-.303 0-.55.291-.55.65M9.7 9.3a.735.735 0 0 0 .05-.917L7.916 5.92c-.201-.27-.548-.296-.776-.059a.735.735 0 0 0-.05.918l1.835 2.463c.2.27.548.296.776.059Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.976 9.463c.303 0 .55-.291.55-.65V3.65c0-.359-.247-.65-.55-.65s-.55.291-.55.65v5.162c0 .359.246.65.55.65Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m6.99 6.99-.002-.65-.55.005c.002.359.25.648.553.646Zm-.56-3.336c0-.173.057-.339.16-.46a.51.51 0 0 1 .39-.192h1.16c.92 0 1.749.854 1.749 1.991s-.829 1.992-1.75 1.992l-.693.003-.455.003-.003-.65-.55.004-.003-.534a226 226 0 0 1-.004-1.602zm1.104 2.033a195 195 0 0 1-.003-1.385h.609c.379 0 .65.347.65.691 0 .345-.271.692-.65.692z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M1 5V1h18v4M1 15v4h18v-4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "freebet_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgFreebet;